/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_BeginnerInputs */

const en_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are allowed to swing the way your body naturally moves. Nobody tears your swing apart and rebuilds it from scratch. Start with what you already do well.`)
};

const es_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes permiso para swinguear como tu cuerpo se mueve de forma natural. Nadie desarma tu swing y lo reconstruye desde cero. Empieza con lo que ya haces bien.`)
};

const de_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie dürfen so schwingen, wie sich Ihr Körper natürlich bewegt. Niemand zerreißt Ihren Schwung und baut ihn von Grund auf neu auf. Beginnen Sie mit dem, was Sie bereits gut können.`)
};

const zh_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以按照身体自然的动作方式挥杆。没有人会把你的挥杆拆掉再从零重建。从你已经做得好的地方开始。`)
};

const ar_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك تنفيذ السوينغ بالطريقة التي يتحرك بها جسمك طبيعياً. لا أحد يفكك سوينغك ويعيد بناءه من الصفر. ابدأ بما تُجيده بالفعل.`)
};

const fr_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes autorisé à swinguer comme votre corps bouge naturellement. Personne ne déchire votre swing et ne le reconstruit à partir de zéro. Commencez par ce que vous faites déjà bien.`)
};

const vi_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn được phép swing theo cách cơ thể tự nhiên chuyển động. Không ai tháo swing của bạn rồi dựng lại từ đầu. Bắt đầu với những gì bạn đã làm tốt.`)
};

const sw_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unaruhusiwa kupiga swing jinsi mwili wako unavyosonga kwa kawaida. Hakuna atakayevunja swing yako na kuijenga upya kuanzia mwanzo. Anza na kile unachokifanya vizuri tayari.`)
};

const th_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสวิงได้ตามที่ร่างกายเคลื่อนไหวอย่างเป็นธรรมชาติ ไม่มีใครรื้อสวิงของคุณแล้วสร้างใหม่ตั้งแต่ศูนย์ เริ่มจากสิ่งที่คุณทำได้ดีอยู่แล้ว`)
};

const bs_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozvoljeno ti je da swinguješ onako kako se tvoje tijelo prirodno kreće. Niko ne rastavlja tvoj swing i ne gradi ga iznova od nule. Počni s onim što već radiš dobro.`)
};

const ja_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体が自然に動くとおりにスイングして構いません。誰もあなたのスイングをばらばらにして、一から作り直したりはしません。すでに上手にできていることから始めましょう。`)
};

const ko_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몸이 자연스럽게 움직이는 대로 스윙해도 됩니다. 누구도 당신의 스윙을 뜯어고쳐 처음부터 다시 만들지 않습니다. 이미 잘하고 있는 것에서 시작하세요.`)
};

const pt_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode fazer o swing do jeito que o corpo se move naturalmente. Ninguém desmonta o seu swing e reconstrói do zero. Comece pelo que você já faz bem.`)
};

const it_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi fare lo swing nel modo in cui il tuo corpo si muove naturalmente. Nessuno smonta il tuo swing per ricostruirlo da zero. Parti da ciò che sai già fare bene.`)
};

const sv_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du får svinga så som din kropp naturligt rör sig. Ingen river sönder din sving och bygger om den från grunden. Börja med det du redan gör bra.`)
};

const nl_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je mag swingen zoals je lichaam van nature beweegt. Niemand breekt je swing af om hem vanaf nul opnieuw te bouwen. Begin met wat je al goed doet.`)
};

const da_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du må gerne svinge sådan som din krop naturligt bevæger sig. Ingen river dit sving fra hinanden og bygger det op fra bunden. Start med det, du allerede gør godt.`)
};

const nb_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du får svinge slik kroppen din naturlig beveger seg. Ingen river svingen din fra hverandre og bygger den opp fra bunnen. Start med det du allerede gjør godt.`)
};

const fi_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat svingata niin kuin kehosi luonnostaan liikkuu. Kukaan ei pura svingiäsi osiin ja rakenna sitä alusta. Aloita siitä, minkä teet jo hyvin.`)
};

const pl_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz swingować tak, jak Twoje ciało naturalnie się porusza. Nikt nie rozbierze Twojego swingu na części, by zbudować go od zera. Zacznij od tego, co już robisz dobrze.`)
};

const ru_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете выполнять свинг так, как естественно двигается ваше тело. Никто не будет разбирать ваш свинг на части и строить его с нуля. Начните с того, что у вас уже хорошо получается.`)
};

const tr_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vücudunuzun doğal hareket ettiği şekilde swing yapabilirsiniz. Kimse swinginizi parçalara ayırıp sıfırdan yeniden kurmaz. Zaten iyi yaptığınız şeyle başlayın.`)
};

const hi_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको अपने शरीर की स्वाभाविक गति से स्विंग करने की अनुमति है। कोई आपके स्विंग को तोड़कर शून्य से नहीं बनाता। जो आप पहले से अच्छा करते हैं, वहीं से शुरू करें।`)
};

const id_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda boleh mengayun sesuai cara tubuh Anda bergerak secara alami. Tidak ada yang akan membongkar ayunan Anda lalu membangunnya ulang dari nol. Mulailah dari apa yang sudah Anda lakukan dengan baik.`)
};

const ms_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dibenarkan menghayun mengikut cara tubuh anda bergerak secara semula jadi. Tiada siapa yang akan merombak hayunan anda dan membinanya semula dari awal. Mulakan dengan apa yang sudah anda lakukan dengan baik.`)
};

const cs_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Můžete švihat tak, jak se vaše tělo přirozeně pohybuje. Nikdo váš švih nerozebere a nebude ho stavět od nuly. Začněte tím, co už děláte dobře.`)
};

const el_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιτρέπεται να κάνετε σβινγκ όπως κινείται φυσικά το σώμα σας. Κανείς δεν διαλύει το σβινγκ σας για να το χτίσει από την αρχή. Ξεκινήστε από ό,τι ήδη κάνετε καλά.`)
};

const he_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מותר לכם לבצע סווינג בדרך שבה הגוף שלכם זז באופן טבעי. אף אחד לא מפרק את הסווינג שלכם ובונה אותו מחדש מאפס. התחילו ממה שאתם כבר עושים טוב.`)
};

const af_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jy mag swaai soos jou liggaam natuurlik beweeg. Niemand skeur jou swaai uitmekaar en herbou dit van nuuts af nie. Begin met wat jy reeds goed doen.`)
};

const hu_method_content_step_02_beginner = /** @type {(inputs: Method_Content_Step_02_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szabadon üthetsz úgy, ahogy a tested természetesen mozog. Senki sem szedi szét a swingedet, hogy nulláról építse újra. Kezdd azzal, amit már jól csinálsz.`)
};

/**
* | output |
* | --- |
* | "You are allowed to swing the way your body naturally moves. Nobody tears your swing apart and rebuilds it from scratch. Start with what you already do well." |
*
* @param {Method_Content_Step_02_BeginnerInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_beginner = /** @type {((inputs?: Method_Content_Step_02_BeginnerInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_BeginnerInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_beginner(inputs)
	if (locale === "de") return de_method_content_step_02_beginner(inputs)
	if (locale === "zh") return zh_method_content_step_02_beginner(inputs)
	if (locale === "ar") return ar_method_content_step_02_beginner(inputs)
	if (locale === "fr") return fr_method_content_step_02_beginner(inputs)
	if (locale === "vi") return vi_method_content_step_02_beginner(inputs)
	if (locale === "sw") return sw_method_content_step_02_beginner(inputs)
	if (locale === "th") return th_method_content_step_02_beginner(inputs)
	if (locale === "bs") return bs_method_content_step_02_beginner(inputs)
	if (locale === "ja") return ja_method_content_step_02_beginner(inputs)
	if (locale === "ko") return ko_method_content_step_02_beginner(inputs)
	if (locale === "pt") return pt_method_content_step_02_beginner(inputs)
	if (locale === "it") return it_method_content_step_02_beginner(inputs)
	if (locale === "sv") return sv_method_content_step_02_beginner(inputs)
	if (locale === "nl") return nl_method_content_step_02_beginner(inputs)
	if (locale === "da") return da_method_content_step_02_beginner(inputs)
	if (locale === "nb") return nb_method_content_step_02_beginner(inputs)
	if (locale === "fi") return fi_method_content_step_02_beginner(inputs)
	if (locale === "pl") return pl_method_content_step_02_beginner(inputs)
	if (locale === "ru") return ru_method_content_step_02_beginner(inputs)
	if (locale === "tr") return tr_method_content_step_02_beginner(inputs)
	if (locale === "hi") return hi_method_content_step_02_beginner(inputs)
	if (locale === "id") return id_method_content_step_02_beginner(inputs)
	if (locale === "ms") return ms_method_content_step_02_beginner(inputs)
	if (locale === "cs") return cs_method_content_step_02_beginner(inputs)
	if (locale === "el") return el_method_content_step_02_beginner(inputs)
	if (locale === "he") return he_method_content_step_02_beginner(inputs)
	if (locale === "af") return af_method_content_step_02_beginner(inputs)
	if (locale === "hu") return hu_method_content_step_02_beginner(inputs)
	return en_method_content_step_02_beginner(inputs)
});